module.exports = __webpack_public_path__ + "img/turbo_off.313e8b33.png";